<template>
  <div class="acc_hl">
    {{ accHeadline }}
    
    <img v-if=headImgID v-bind:src="getPolopolyImgUrl( headImgID, headImgDerivate)">
    <div v-if=headImgID class="acc_hl_credit">Foto: {{ headImgCredit }}</div>
    <div style="height:10px"><!-- --></div>
  </div>
</template>

<script>

export default {
  name: 'AccHead',
  props: {
    accHeadline: String,
    headImgCredit: String,
    headImgID: String,
    headImgFormat: String
  },  
  computed: {
       headImgDerivate: function () {
   
        if (this.headImgFormat == '1-1')
        return 'format_top1_portrait-hq'
        if (this.headImgFormat == '16-9')
        return 'media_in_article_large'
        if (this.headImgFormat == '8-3')
        return 'format8_3-retina'
        else  
        return 'media_in_article_large_original'
    }
    
  },               
  methods: { 
      getPolopolyImgUrl: function (id, derivate) {
      return 'https://www.faz.net/ppmedia/' + id + '/' + derivate
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/styles.css';
</style>
